import App from '../App';
import ErrorPage from '../ErrorPage';
import Home from './Home';
import { ADMIN, AIRPORTS, AUDITLOG, CABINCAST, CABINCAST_AUDIOFILES, CABINCAST_PLAYLISTS, DASHBOARD, DELAYCOMM, FLIGHTLIST, PREMMEALLIST, SIGN_IN, USERFEEDBACK } from '../common/paths';
import Login from './Login/Login';
import LoginCallback from './Login/LoginCallback';
import FlightList from './Flights/FlightList';
import AudioFiles from './CabinCast/AudioFiles/AudioFiles';
import Playlists from './CabinCast/Playlists/Playlists';
import AuditLog from './AuditLog';
import Dashboard from '../Dashboard/Dashboard';
import DelayComm from './DelayComm/DelayComm';
import UserFeedback from './UserFeedback/UserFeedback';
import UserFeedbackDetails from './UserFeedback/UserFeedbackDetails';
import Airports from './Airports/Airports';
import PremMealList from './PremMeals/PremMealList';
import PremMealDetails from './PremMeals/PremMealDetails';

const routes = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        // path: HOME,
        element: <Home/>,
      },
      {
            path: DASHBOARD,
            element: <Dashboard />,
      },
      {
        path: '/' + FLIGHTLIST,
        element: <FlightList />
      },
      {
        path: PREMMEALLIST,
        children: [  
          {
            path: '',             
            element: <PremMealList />,
          },        
          {
            path: '/' + PREMMEALLIST + '/:id',             
            element: <PremMealDetails />,
          }
        ]
      },
      {
        path: '/' + AUDITLOG,
        element: <AuditLog />
      },
      {
        path: '/' + DELAYCOMM,
        element: <DelayComm />
      },
      {
        path: USERFEEDBACK,
        children: [
          {
            path: '',
            element: <UserFeedback />,
          },
          {
            path: '/' + USERFEEDBACK + '/:id',
            element: <UserFeedbackDetails />,
          }
        ]
      },
      {
        path: '/' + CABINCAST,
        children: [
          {
            path: '/' + CABINCAST + '/' + CABINCAST_AUDIOFILES,
            element: <AudioFiles />
          },
          {
            path: '/' + CABINCAST + '/' + CABINCAST_PLAYLISTS,
            element: <Playlists />
          },
        ]
      },
      {
        path: '/' + ADMIN,
        children: [
          {
            path: '/' + ADMIN + '/' + AIRPORTS,
            element: <Airports />
          }
        ]
      },
      {
        path: '/' + SIGN_IN,
        element: <Login />
      },
      {
        path: '/' + SIGN_IN + '/oauth2/code/cognito',
        element: <LoginCallback />
      }
    ],
  },
];

export default routes;